import React from 'react';
import './Contacts.css';


const ContactCardEdit = (props) => {
  const person = props.person ? props.person : null;
  if (!person) {
    return (
      <div>loading...</div>
    )
  }

  return (
    <div className="Person">
      {props.person._source.app === 'exaContact' ?
        <p><b>{props.person._source.contactId}</b> from {props.person._source.exaOwner}</p> : null
      }

      <p>Name: <input type="text" onChange={props.changed} value={props.person._source.nameFull} /></p>
      <p>Email: <input type="text" onChange={props.changed} value={props.person._source.emailAddress} /></p>
      <p>Sharing: <input type="text" onChange={props.changed} value={props.person._source.exaShare} /></p>
      <p>Customer Labels: <input type="text" onChange={props.changed} value={props.person._source.exaLabel} /></p>
      <p>Record Links: <input type="text" onChange={props.changed} value={props.person._source.exaLink} /></p>
      <p>Mobile Phone: <input type="text" onChange={props.changed} value={props.person._source.phoneMobile} /></p>
      <p>Home Phone: <input type="text" onChange={props.changed} value={props.person._source.phoneHome} /></p>
      <p>Birthday: <input type="text" onChange={props.changed} value={props.person._source.birthDate} /></p>
      <p>Notes: <input type="text" onChange={props.changed} value={props.person._source.notes} /></p>

      {props.person._source.appContactId && props.person._source.appContactId !== props.person._source.contactId ?
        <p>{props.person._source.app} Id: {props.person._source.appContactId}</p> : null
      }
      {props.person._source.app && props.person._source.app !== 'exaContact' ?
        <p>source: {props.person._source.app} account of {props.person._source.appOwner} </p> : null
      }
      {props.person._id ?
        <p>db _id: {props.person._id}</p> : null
      }
      {props.person._source.exaLabel ?
        <p>labels: {props.person._source.exaLabel}</p> : null
      }
      {props.person._source.exaShare ?
        <p>sharing: {props.person._source.exaShare}</p> : null
      }
    </div>
  );
}

export default ContactCardEdit;



// WEBPACK FOOTER //
// ./src/containers/Contacts/ContactCardEdit.js